import { Box, Skeleton } from "@mui/material";
import save20Icon from "../../assets/icons/save20.svg";

const featureWidths = [82, 76, 88, 68];

const SubscriptionPlanSkeletonCard = ({ highlighted = false }) => (
  <Box
    sx={{
      width: "100%",
      minHeight: { xs: 430, md: 450 },
      borderRadius: "1rem",
      background: highlighted
        ? "linear-gradient(180deg, rgba(1, 170, 245, 0.18) 0%, rgba(255, 255, 255, 1) 37%)"
        : "#ffffff",
      boxShadow: "0 1rem 1.875rem rgba(15, 23, 42, 0.08)",
      px: { xs: 2.5, md: 3 },
      py: { xs: 2.5, md: 3 },
      position: "relative",
      overflow: "hidden",
    }}
  >
    {highlighted ? (
      <Skeleton
        variant="circular"
        width={92}
        height={92}
        sx={{
          position: "absolute",
          top: 34,
          right: 26,
          bgcolor: "rgba(255, 170, 0, 0.34)",
        }}
      />
    ) : null}

    <Skeleton variant="text" width={96} height={40} sx={{ mb: 0.5 }} />
    <Skeleton variant="text" width={170} height={64} />
    <Skeleton variant="text" width={210} height={26} sx={{ mt: -0.5 }} />
    <Skeleton
      variant="rounded"
      width="100%"
      height={2}
      sx={{ my: { xs: 2.5, md: 3.25 }, bgcolor: "rgba(15, 23, 42, 0.08)" }}
    />
    <Skeleton variant="text" width="84%" height={30} />
    <Skeleton variant="text" width="72%" height={30} sx={{ mb: 2.25 }} />

    {featureWidths.map((width, index) => (
      <Box
        key={`subscription-card-feature-${width}-${index}`}
        sx={{
          display: "grid",
          gridTemplateColumns: "1.75rem minmax(0, 1fr)",
          alignItems: "center",
          columnGap: 1.25,
          mb: 1.35,
        }}
      >
        <Skeleton
          variant="circular"
          width={22}
          height={22}
          sx={{ bgcolor: "rgba(0, 128, 0, 0.22)" }}
        />
        <Skeleton variant="text" width={`${width}%`} height={28} />
      </Box>
    ))}

    <Skeleton
      variant="rounded"
      width="90%"
      height={42}
      sx={{ borderRadius: "0.5rem", mx: "auto", mt: 3.25 }}
    />
  </Box>
);

const SubscriptionPageSkeleton = () => (
  <Box
    sx={{
      width: "100%",
      minHeight: "calc(100vh - 4.5rem)",
      backgroundColor: "#fafafa",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      px: { xs: 2, md: 4 },
      pt: { xs: 4, md: 5.2 },
      pb: { xs: 4, md: 7 },
    }}
  >
    <Skeleton
      variant="text"
      sx={{
        width: { xs: "86%", sm: 460, md: 520 },
        height: { xs: 36, md: 44 },
        maxWidth: "100%",
        mb: { xs: 2.5, md: 4 },
      }}
    />

    <Box
      sx={{
        position: "relative",
        width: { xs: 300, sm: 330 },
        maxWidth: "calc(100vw - 3rem)",
        height: 64,
        mb: { xs: 7, md: 8 },
      }}
    >
      <Skeleton
        variant="rounded"
        width="100%"
        height={64}
        sx={{
          borderRadius: "1rem",
          bgcolor: "rgba(122, 209, 248, 0.38)",
          border: "2px solid rgba(122, 209, 248, 0.72)",
        }}
      />
      <Skeleton
        variant="rounded"
        width="47%"
        height={50}
        sx={{
          borderRadius: "0.875rem",
          position: "absolute",
          left: 7,
          top: 7,
          bgcolor: "rgba(1, 170, 245, 0.52)",
        }}
      />
      <Box
        component="img"
        src={save20Icon}
        alt=""
        aria-hidden="true"
        sx={{
          position: "absolute",
          width: { xs: 150, md: 240 },
          top: { xs: 42, md: 58 },
          right: { xs: -42, sm: -188 },
          opacity: 0.18,
          filter: "grayscale(1)",
          pointerEvents: "none",
        }}
      />
    </Box>

    <Box
      sx={{
        width: "min(82.5rem, 100%)",
        display: "grid",
        gridTemplateColumns: {
          xs: "1fr",
          md: "repeat(3, minmax(0, 26.25rem))",
        },
        gap: { xs: 2, md: 2 },
        alignItems: "stretch",
        justifyContent: "center",
      }}
    >
      <SubscriptionPlanSkeletonCard />
      <SubscriptionPlanSkeletonCard highlighted />
      <SubscriptionPlanSkeletonCard />
    </Box>
  </Box>
);

export default SubscriptionPageSkeleton;
